export const individualsES = {
  Individuals: 'Individuals',
  'Folder Name': 'Folder Name',
  'Only Probands': 'Only Probands',
  'All Individuals': 'All Individuals',
  'Individual Name': 'Individual Name',
  'New Individual': 'New Individual',
  'Create': 'Create',
  'Sex': 'Sex',
  'Male': 'Male',
  'Female': 'Female',
  'Unknown': 'Unknown',
  'There no individuals to display': 'There no individuals to display',
  'Select an individual to view invites': 'Select an individual to view invites',
  'of items in': 'of items in',
  Folder: 'Folder',
  'There are no invites to display': 'There are no invites to display',
  'Operation canceled': 'Operation canceled',
  'Failed to get data': 'Failed to get data',
  'Failed to get individuals columns': 'Failed to get individuals columns',
  'Failed to get individuals': 'Failed to get individuals',
  'Failed to get invites': 'Failed to get invites',
  'Failed to get invites columns': 'Failed to get invites columns',
  'Failed to save resized columns': 'Failed to save resized columns',
  Ok: 'Ok',
  'Set as Default for All Users': 'Set as Default for All Users',
  'Set as Default for Specific Profiles': 'Set as Default for Specific Profiles',
  'Apply Current Columns Now to All Users': 'Apply Current Columns Now to All Users',
  'Apply Current Columns Now to Specific Profiles': 'Apply Current Columns Now to Specific Profiles',
  'Restore Columns to Default': 'Restore Columns to Default',
  'Select Profile': 'Select Profile',
  'Failed to select profile': 'Failed to select profile',
  'Failed to get profiles': 'Failed to get profiles',
  'Add Column': 'Add Column',
  'Delete Column': 'Delete Column',
  'Apply': 'Apply',
  'Rename Individual': 'Rename Individual',
  'Type new individual name': 'Type new individual name',
  Rename: 'Rename',
  'Failed to rename individual': 'Failed to rename individual',
  'Open Datasheet': 'Open Datasheet',
  'Open Pedigree': 'Open Pedigree',
  'Open Test Results': 'Open Test Results',
  'Generate Letter': 'Generate Letter',
  'Individual successfully renamed': 'Individual successfully renamed',
  'Information Message': 'Information Message',
  'Batch Letters': 'Batch Letters',
  'New Invite': 'New Invite',
  'Select a Questionnaire you want to invite patients to': 'Select a Questionnaire you want to invite patients to',
  'Questionnaire Name': 'Questionnaire Name',
  'Datasheet Format Name': 'Datasheet Format Name',
  Previous: 'Previous',
  'Send an Invite': 'Send an Invite',
  Next: 'Next',
  'Edit content of your email': 'Edit content of your email',
  'Email Subject': 'Email Subject',
  "Insert {NAME} placeholder": "Insert {NAME} placeholder",
  "Insert hyperlink with {LINK} placeholder": "Insert hyperlink with {LINK} placeholder",
  "The Questionnaire invitation emails were successfully submitted": "The Questionnaire invitation emails were successfully submitted",
  'Launch Questionnaire': 'Launch Questionnaire',
  'Launch New Questionnaire': 'Launch New Questionnaire',
  'Open Questionnaire': 'Open Questionnaire',
  'Select a Questionnaire': 'Select a Questionnaire',
  'New Questionnaire for': 'New Questionnaire for',
  'Open Questionnaire for': 'Open Questionnaire for',
  'Status': 'Status',
  'Date Started': 'Date Started',
  'Date Completed': 'Date Completed',
  'Invited By': 'Invited By',
  'Operation failed': 'Operation failed',
  "Text": "Text",
  'Failed to save columns': 'Failed to save columns',
  'There is a problem with the email address for this individual, please enter a valid email address': 'There is a problem with the email address for this individual. Please enter a valid email address',
  "Selected questionnaire doesn't have Datasheet Format": "Selected questionnaire doesn't have Datasheet Format",
  "The individual you selected must be moved to a new pedigree in order to send a Family History Questionnaire.": "The individual you selected must be moved to a new pedigree in order to send a Family History Questionnaire.",
  "What is the name of the new pedigree?": "What is the name of the new pedigree?",
  "Select a folder": "Select a folder",
  "The Pedigree Name you entered is already used in this database, please choose another name": "The Pedigree Name you entered is already used in this database, please choose another name",
  "Failed to create pedigree": "Failed to create pedigree",
  "Failed to get family members data": "Failed to get family members data",
  "Failed to get family data": "Failed to get family data",
  patient: 'patient',
  "Send Reminder": "Send Reminder",
  "Send a Reminder": "Send a Reminder",
  "Individual name already exists in this folder": "Individual name already exists in this folder",
  "The Questionnaire reminder email was successfully sent.": "The Questionnaire reminder email was successfully sent.",
  "New Invites": "New Invites",
  "Email appears to be invalid": "Email appears to be invalid",
  'The Questionnaire invitation emails were successfully submitted': 'The Questionnaire invitation emails were successfully submitted',
};